import React from 'react';
import { Select } from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';

import { AreaMappings } from './';
import { Language } from '../../utils/language';
import { Maybe, number, Nothing } from 'purify-ts';
import { Field, updateValue, touchField } from '../formTypes';
import * as R from 'remeda';
import { RemoteData, foldRemoteData } from '../../utils/remoteData';
import { Omraader } from './types';

interface FylkeSelectSingleProps {
  language: Language;
  areaMappings: AreaMappings | undefined;
  omraader: RemoteData<Error, Omraader>;
  selectedFylke: Field<Maybe<number>>;
  selectFylke: React.Dispatch<Field<Maybe<number>>>;
}

export default function SharedFylkeSelectSingle({
  language = 'nb_NO',
  areaMappings,
  selectedFylke,
  omraader,
  selectFylke,
}: FylkeSelectSingleProps) {
  return (
    <div className="area-form-field" style={{ width: '100%' }}>
      <FormControl
        required
        error={selectedFylke.value === Nothing && selectedFylke.touched}
        style={{ width: '100%' }}
        variant="filled"
      >
        <InputLabel id="fylke-select-label">{language === 'nb_NO' ? 'Velg fylke' : 'Vel fylke'}</InputLabel>
        <Select
          labelId="fylke-select-label"
          id="fylke-select"
          name="selectedFylke"
          style={{ textAlign: 'left', width: '100%' }}
          value={selectedFylke.value.caseOf({ Nothing: () => 0, Just: fylkeNr => fylkeNr })}
          autoWidth
          error={selectedFylke.value === Nothing && selectedFylke.touched}
          onBlur={() => selectFylke(touchField(selectedFylke))}
          onChange={(event: any) => {
            const decodedNumber = number.decode(event.target.value).toMaybe();

            selectFylke(updateValue(selectedFylke, decodedNumber));
          }}
        >
          {foldRemoteData(
            omraader,
            () => [],
            () => [],
            e => [],
            o => {
              return R.pipe(
                o,
                R.prop('fylkerMedKommuner'),
                R.sortBy(f => f.navn),
                R.map(fylke => (
                  <MenuItem key={fylke.nummer} value={fylke.nummer}>
                    {fylke.navn}
                  </MenuItem>
                )),
              );
            },
          )}
        </Select>
        <FormHelperText>{language === 'nb_NO' ? 'Fylke må velges' : 'Fylke må veljas'}</FormHelperText>
      </FormControl>
    </div>
  );
}
